export const localStorageCheckIfInstructionIsDone = () => {
    const instructionDone = localStorage.getItem('instructions complete')
    return instructionDone === 'done'
}

export const localStorageSetInstructionIsDone = () => {
    localStorage.setItem('instructions complete', 'done')
}
